import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { appBarHeight } from "@/components/@common/AppBar/AppBar";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { Button, Divider } from "@bookips/sds";
import Link from "next/link";
import React, { useEffect, useRef } from "react";
import CategoryHeader from "./components/CategoryHeader";
import CategorySectionComponent from "./components/CategorySection";
import ShortcutList from "./components/ShortcutList";
import SubjectList from "./components/SubjectList";
import { useCategoryMenu } from "./hooks/useCategoryMenu";
// Tablet 레이아웃 (744px ~ 1200px)
// Mobile과 같은 헤더/하단바 + Desktop처럼 가로 여러 컬럼 배치
const CategoryMenuTablet = ()=>{
    const { isOpen , selectedMenuId , menus , selectedMenu , categoryColumns , menuFooter , handleSubjectClick , handleItemClick , handleClose  } = useCategoryMenu();
    // 카테고리 리스트 스크롤 컨테이너 ref
    const categoryScrollRef = useRef(null);
    // 과목 변경 시 스크롤 최상단으로 리셋
    useEffect(()=>{
        if (categoryScrollRef.current) {
            categoryScrollRef.current.scrollTop = 0;
        }
    }, [
        selectedMenuId
    ]);
    const content = /*#__PURE__*/ _jsxs("div", {
        className: cn("category-menu-portal fixed inset-0 flex flex-col bg-white", isOpen ? "z-side-menu" : "pointer-events-none -z-10"),
        style: {
            paddingBottom: appBarHeight
        },
        children: [
            /*#__PURE__*/ _jsx(CategoryHeader, {
                onClose: handleClose
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex min-h-0 flex-1 overflow-hidden",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex h-full w-[120px] max-w-[120px] shrink-0 items-center overflow-y-auto bg-gray-50",
                        children: /*#__PURE__*/ _jsx(SubjectList, {
                            items: menus,
                            selectedId: selectedMenuId,
                            onItemClick: handleSubjectClick
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex min-w-0 flex-1 flex-col overflow-hidden",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                ref: categoryScrollRef,
                                className: "custom-scrollbar flex min-w-0 flex-1 overflow-x-auto overflow-y-hidden",
                                children: categoryColumns.map((section)=>/*#__PURE__*/ _jsx("div", {
                                        className: cn("h-full flex-1 overflow-y-auto", "border-r border-gray-100"),
                                        children: section.groups.map((group, index)=>/*#__PURE__*/ _jsxs(React.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsx(CategorySectionComponent, {
                                                        title: group.groupTitle,
                                                        titleLink: group.groupLink,
                                                        items: group.items,
                                                        onItemClick: handleItemClick
                                                    }),
                                                    index < section.groups.length - 1 && /*#__PURE__*/ _jsx(Divider, {
                                                        className: "border-gray-100"
                                                    })
                                                ]
                                            }, group.groupSeq))
                                    }, section.sectionNumber))
                            }),
                            (selectedMenu === null || selectedMenu === void 0 ? void 0 : selectedMenu.ctaButtonUrl) && (selectedMenu === null || selectedMenu === void 0 ? void 0 : selectedMenu.ctaButtonTitle) && /*#__PURE__*/ _jsx("div", {
                                className: "px-5 py-3",
                                children: /*#__PURE__*/ _jsx(Link, {
                                    href: selectedMenu.ctaButtonUrl,
                                    onClick: ()=>{
                                        mixpanelEvent("Category Board Item Clicked", {
                                            "Item Type": "CTA Button",
                                            "Item Name": selectedMenu.ctaButtonTitle
                                        });
                                        handleClose();
                                    },
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        variant: "stroke",
                                        color: "secondary",
                                        size: "md",
                                        className: "w-full",
                                        children: selectedMenu.ctaButtonTitle
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ShortcutList, {
                items: menuFooter,
                onItemClick: handleClose,
                variant: "tablet"
            })
        ]
    });
    return content;
};
export default CategoryMenuTablet;
